module.exports = __webpack_public_path__ + "static/media/15f-04_Serie-Blanca-6-2015-300x200cm-oleo-sobre-papel.179c09bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15f/15f-04_Serie-Blanca-6-2015-300x200cm-oleo-sobre-papel.jpg
// module id = 177
// module chunks = 0